import { autoRegisterFeature } from '@store/features/factory';
import { appointmentsFeature } from './store/feature';

// Auto-register the appointments feature
autoRegisterFeature(appointmentsFeature);

// Export everything from store
export * from './store';

// Export types
export * from './types';

// Export components
export * from './components';

// Export modal components (for lazy loading in modal registry)
export { default as AppointmentSelectionModal } from './components/AppointmentSelectionModal';

// Export hooks
export * from './hooks';
export { useCurrentDateExpiration } from './store/useCurrentDateExpiration';

// Export utils
export * from './utils/scheduledActionUtils';
export * from './utils/dateTimeFormatters';
export * from './utils/appointmentNotifications';

// Re-export commonly used types for convenience
export type {
  Appointment,
  AppointmentListResponse,
  AppointmentCreate,
  AppointmentUpdate,
  AppointmentSeriesCreate,
  AppointmentSeriesUpdate,
  SeriesResponse,
  PatientInfo,
  SeriesInfo,
} from './types';
